module.exports = __webpack_public_path__ + "media/assets/cardBookNowBronze-657f63898678e28360015f9474f27b51.png";